import { SESSION_TIMER_START, SESSION_TIMER_RESET, SESSION_TIMER_STOP } from './actions.type';
import SettingsInstance from '../api/SettingsInstance';

import {
  SESSION_TIME_SET,
  SESSION_INTERVAL_SET,
  SESSION_INTERVAL_CLEAR
} from './mutations.type';

const SESSION_DURATION_SEC = parseInt(SettingsInstance.sessionTimeout, 10);

const initialState = {
  remainingTime: SESSION_DURATION_SEC,
  timerInterval: null
};

const state = Object.assign({}, initialState);

const actions = {
  [SESSION_TIMER_START](context) {
    context.commit(SESSION_INTERVAL_CLEAR);
    context.commit(SESSION_TIME_SET, SESSION_DURATION_SEC);

    const interval = setInterval(() => {
      if (context.state.remainingTime <= 0) {
        context.dispatch(SESSION_TIMER_STOP);
        localStorage.clear();
        window.location.href = SettingsInstance.baseApiAuth + '/SamlLogoutInit'
      } else {
        context.commit(SESSION_TIME_SET, context.state.remainingTime - 1);
      }
    }, 1000);

    context.commit(SESSION_INTERVAL_SET, interval);
  },

  [SESSION_TIMER_RESET](context) {
    context.dispatch(SESSION_TIMER_START);
  },

  [SESSION_TIMER_STOP](context) {
    context.commit(SESSION_INTERVAL_CLEAR);
  }
};

const mutations = {
  [SESSION_TIME_SET](state, seconds) {
    state.remainingTime = seconds;
  },

  [SESSION_INTERVAL_SET](state, interval) {
    state.timerInterval = interval;
  },

  [SESSION_INTERVAL_CLEAR](state) {
    if (state.timerInterval) {
      clearInterval(state.timerInterval);
      state.timerInterval = null;
    }
  }
};

const getters = {
  sessionRemainingTime(state) {
    return state.remainingTime;
  },

  sessionRemainingTimeFormatted(state) {
    const min = Math.floor(state.remainingTime / 60);
    if (state.remainingTime === SESSION_DURATION_SEC) {
      return `${min} min.`;
    } else if (state.remainingTime > 60) {
      return `${min + 1} min.`;
    }
    return `${state.remainingTime} sek.`;
  },

  getReamingTimeClass(state) {

    // Percentage of time remaining
    let percentage = (state.remainingTime / SESSION_DURATION_SEC) * 100;

    if (percentage < 15) {
      return 'text-danger';
    } else if (percentage < 25) {
      return 'text-warning';
    }

    return '';
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
